import { API_FRESH_REPORT } from 'utils/constants'
import Api from './axiosInstance'

const { REPORT, CATEGORIES, EXPORT, EXPORT_LOGS } = API_FRESH_REPORT

export type FreshReportFilters = {
  // Required by the API - it is the leading key of the collection's index
  store?: string
  category?: string
  dateFrom?: string
  dateTo?: string
}

const buildParams = ({
  limit,
  page,
  filters,
}: {
  limit: number
  page: number
  filters?: FreshReportFilters
}) => {
  const params = new URLSearchParams({
    limit: String(limit),
    page: String(page),
  })

  Object.entries(filters ?? {}).forEach(([key, value]) => {
    if (value) params.append(key, String(value))
  })

  return params
}

const fetchFreshReports = ({
  limit,
  page,
  filters,
}: {
  limit: number
  page: number
  filters?: FreshReportFilters
}) => Api.get({ url: `${REPORT}?${buildParams({ limit, page, filters })}` })

// Categories for the filter dropdown. Served under /fresh-report rather than
// /fresh-category, so a Fresh Report user does not need category-management
// rights just to filter.
const fetchFreshReportCategories = () => Api.get({ url: CATEGORIES })

// Queues a background export of exactly what the filters are showing
const exportFreshReportData = (filters: FreshReportFilters) => {
  const params = new URLSearchParams()

  Object.entries(filters ?? {}).forEach(([key, value]) => {
    if (value) params.append(key, String(value))
  })

  return Api.get({ url: `${EXPORT}?${params}` })
}

// Export logs for Fresh report exports only. Served under /fresh-report
// rather than /log/export, which lists every module and is gated on a page a
// Fresh Report user does not hold.
const fetchFreshReportExportLogs = ({
  limit,
  page,
}: {
  limit: number
  page: number
}) =>
  Api.get({
    url: `${EXPORT_LOGS}?${new URLSearchParams({
      limit: String(limit),
      page: String(page),
    })}`,
  })

export {
  fetchFreshReports,
  fetchFreshReportCategories,
  exportFreshReportData,
  fetchFreshReportExportLogs,
}
